module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [(_vm.step === 1) ? _c('div', {
    staticStyle: {
      "margin-left": "30%",
      "max-width": "600px"
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "bg-white",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-container', {
    staticClass: "coverage-form-container",
    staticStyle: {
      "max-width": "1200px"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex flex-row pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-2 pt-3 label-left"
  }, [_vm._v("Choose Platform "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "max-width": "200px",
      "margin-top": "10px"
    },
    attrs: {
      "outlined": "",
      "hide-details": "",
      "dense": "",
      "items": _vm.platformList,
      "required": "",
      "error-messages": _vm.$v.platform.$error && "Platform is required."
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      },
      "input": function($event) {
        return _vm.$v.platform.$touch()
      }
    },
    model: {
      value: (_vm.platform),
      callback: function($$v) {
        _vm.platform = $$v
      },
      expression: "platform"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-2 pt-3 label-left"
  }, [_vm._v("Inf. Country "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-autocomplete', {
    staticStyle: {
      "max-width": "200px",
      "margin-top": "10px"
    },
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "",
      "multiple": "",
      "required": "",
      "error-messages": _vm.$v.searchSettings.influencerGeos.$error && "Country is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.searchSettings.influencerGeos.$touch()
      }
    },
    model: {
      value: (_vm.searchSettings.influencerGeos),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "influencerGeos", $$v)
      },
      expression: "searchSettings.influencerGeos"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-2 pt-3 label-left"
  }, [_vm._v("Aud. Country "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-autocomplete', {
    staticStyle: {
      "max-width": "200px",
      "margin-top": "10px"
    },
    attrs: {
      "items": _vm.countries,
      "dense": "",
      "hide-selected": "",
      "clearable": "",
      "small-chips": "",
      "outlined": "",
      "hide-details": "auto",
      "label": "",
      "multiple": "",
      "required": "",
      "error-messages": _vm.$v.searchSettings.audGeos.$error && "Country is required."
    },
    on: {
      "input": function($event) {
        return _vm.$v.searchSettings.audGeos.$touch()
      }
    },
    model: {
      value: (_vm.searchSettings.audGeos),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "audGeos", $$v)
      },
      expression: "searchSettings.audGeos"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    staticStyle: {
      "max-width": "90px",
      "margin-top": "10px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.percentOptions
    },
    model: {
      value: (_vm.searchSettings.audGeoPercent),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "audGeoPercent", $$v)
      },
      expression: "searchSettings.audGeoPercent"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-2 pt-3 label-left"
  }, [_vm._v("Followers "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.from
    },
    model: {
      value: (_vm.searchSettings.followers.from),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings.followers, "from", $$v)
      },
      expression: "searchSettings.followers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.searchConfig.followerOptions.to
    },
    model: {
      value: (_vm.searchSettings.followers.to),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings.followers, "to", $$v)
      },
      expression: "searchSettings.followers.to"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-row pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "h4 mb-2 pt-3 label-left"
  }, [_vm._v("Gender "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "mt-0",
    model: {
      value: (_vm.searchSettings.infGender),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "infGender", $$v)
      },
      expression: "searchSettings.infGender"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Male or Female",
      "value": "KNOWN"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Male",
      "value": "MALE"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Female",
      "value": "FEMALE"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-5 mb-5 justify-end"
  }, [_c('v-btn', {
    staticStyle: {
      "min-width": "120px"
    },
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeNext()
      }
    }
  }, [_c('v-icon', _vm._g({}, _vm.on), [_vm._v("mdi-skip-next")]), _vm._v(" Next\n        ")], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex flex-row pt-2"
  }, [_c('div', {
    staticClass: "pr-2"
  }, [_c('v-text-field', {
    staticClass: "min-max-200",
    attrs: {
      "label": "Bio",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchInf()
      }
    },
    model: {
      value: (_vm.searchSettings.bio),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "bio", $$v)
      },
      expression: "searchSettings.bio"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pr-2"
  }, [_c('v-text-field', {
    staticClass: "min-max-200",
    attrs: {
      "label": "Keywords",
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchInf()
      }
    },
    model: {
      value: (_vm.searchSettings.keywords),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "keywords", $$v)
      },
      expression: "searchSettings.keywords"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row pt-2"
  }, [_c('div', {
    staticClass: "pr-2"
  }, [_c('v-combobox', {
    staticClass: "min-max-200",
    attrs: {
      "label": "Mentions",
      "outlined": "",
      "dense": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "auto"
    },
    on: {
      "change": function($event) {
        return _vm.searchInf()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === String(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                            " + _vm._s(item) + "\n                          ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                            $delete\n                          ")])], 1) : _vm._e(), _vm._v(" "), (item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                            $delete\n                          ")])], 1) : _vm._e()]
      }
    }], null, false, 742319186),
    model: {
      value: (_vm.searchSettings.mentions),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "mentions", $$v)
      },
      expression: "searchSettings.mentions"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pr-2"
  }, [_c('v-combobox', {
    staticClass: "min-max-200",
    attrs: {
      "label": "Hashtags",
      "outlined": "",
      "dense": "",
      "chips": "",
      "clearable": "",
      "multiple": "",
      "hide-details": "auto"
    },
    on: {
      "change": function($event) {
        return _vm.searchInf()
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === String(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                            " + _vm._s(item) + "\n                          ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                            $delete\n                          ")])], 1) : _vm._e(), _vm._v(" "), (item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                            $delete\n                          ")])], 1) : _vm._e()]
      }
    }], null, false, 742319186),
    model: {
      value: (_vm.searchSettings.hashtags),
      callback: function($$v) {
        _vm.$set(_vm.searchSettings, "hashtags", $$v)
      },
      expression: "searchSettings.hashtags"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row pt-2"
  }, [_c('div', {
    staticClass: "pr-2"
  }, [_c('v-autocomplete', {
    staticClass: "search-keyword min-max-200",
    attrs: {
      "items": _vm.audLookItems,
      "loading": _vm.audLookLoading,
      "outlined": "",
      "hide-details": "",
      "chips": "",
      "dense": "",
      "label": "Aud. Lookalikes",
      "search-input": _vm.newAudLookKeyword
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newAudLookKeyword = $event
      },
      "update:search-input": function($event) {
        _vm.newAudLookKeyword = $event
      },
      "keyup": _vm.searchAudLookalike
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          staticClass: "v-chip--select-multi",
          attrs: {
            "input-value": data.selected,
            "disabled": data.disabled,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeAudLookKeyword()
            }
          }
        }, [_vm._v(_vm._s(data.item))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("@" + _vm._s(data.item))]), _vm._v(" "), _c('v-list-item-subtitle')], 1)]
        ]
      }
    }], null, false, 4060976889),
    model: {
      value: (_vm.audLookKeyword),
      callback: function($$v) {
        _vm.audLookKeyword = $$v
      },
      expression: "audLookKeyword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pr-2"
  }, [_c('v-autocomplete', {
    staticClass: "search-keyword min-max-200",
    attrs: {
      "items": _vm.infLookItems,
      "loading": _vm.lookLoading,
      "outlined": "",
      "hide-details": "",
      "chips": "",
      "dense": "",
      "label": "Inf. Lookalikes",
      "search-input": _vm.newInfLookKeyword
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newInfLookKeyword = $event
      },
      "update:search-input": function($event) {
        _vm.newInfLookKeyword = $event
      },
      "keyup": _vm.searchInfLookalike
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          staticClass: "v-chip--select-multi",
          attrs: {
            "input-value": data.selected,
            "disabled": data.disabled,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeLookKeyword()
            }
          }
        }, [_vm._v(_vm._s(data.item))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("@" + _vm._s(data.item))]), _vm._v(" "), _c('v-list-item-subtitle')], 1)]
        ]
      }
    }], null, false, 3169878793),
    model: {
      value: (_vm.infLookKeyword),
      callback: function($$v) {
        _vm.infLookKeyword = $$v
      },
      expression: "infLookKeyword"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "pr-2 pt-2"
  }, [_c('v-autocomplete', {
    staticClass: "search-keyword min-max-250",
    attrs: {
      "items": _vm.searchItems,
      "item-text": "tag",
      "loading": _vm.keywordLoading,
      "multiple": "",
      "outlined": "",
      "hide-details": "",
      "chips": "",
      "dense": "",
      "label": "Search by Topic",
      "search-input": _vm.newKeyword
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newKeyword = $event
      },
      "update:search-input": function($event) {
        _vm.newKeyword = $event
      },
      "keyup": _vm.searchByKeywords
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          staticClass: "v-chip--select-multi",
          attrs: {
            "input-value": data.selected,
            "disabled": data.disabled,
            "close": ""
          },
          on: {
            "click:close": function($event) {
              return _vm.removeKeyword(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.item.tag))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(data.item.tag))]), _vm._v(" "), _c('v-list-item-subtitle')], 1)]
        ]
      }
    }], null, false, 400024750),
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    staticClass: "topic-platform-select min-max-250 pt-2",
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": _vm.platformList
    },
    on: {
      "change": function($event) {
        return _vm.paginate()
      }
    },
    model: {
      value: (_vm.platform),
      callback: function($$v) {
        _vm.platform = $$v
      },
      expression: "platform"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right pt-2"
  }, [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.searchInf
    }
  }, [_vm._v("Search")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "pt-2",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.openSettingsDialog
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "red lighten-2",
      "dark": ""
    }
  }, [_vm._v("settings")])], 1)], 1)]), _vm._v(" "), _c('settings-modal', {
    attrs: {
      "value": _vm.dialog,
      "oldSettings": _vm.searchSettings
    },
    on: {
      "saveSettings": _vm.saveSettings
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  })], 1)], 1), _vm._v(" "), (_vm.wordCloudData.length) ? _c('div', {
    staticClass: "text-center mt-3 mb-3",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', [_c('vue-word-cloud', {
    staticStyle: {
      "position": "relative",
      "max-width": "700px",
      "height": "200px",
      "margin-left": "25%"
    },
    attrs: {
      "v-show": true,
      "words": _vm.wordCloudData,
      "color": function (ref) { return _vm.getRandomColor(); },
      "animation-duration": 1,
      "font-size-ratio": 2,
      "spacing": 0.5,
      "font-family": "Roboto"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-sm-6 pb-0",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('strong', [_vm._v("Total Influencers: " + _vm._s(_vm._f("thousandSeprator")(_vm.totalItems)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('v-text-field', {
    staticClass: "float-right mb-2",
    staticStyle: {
      "min-width": "500px",
      "max-width": "500px"
    },
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.iqDataTableSearch),
      callback: function($$v) {
        _vm.iqDataTableSearch = $$v
      },
      expression: "iqDataTableSearch"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "warning",
      "small": ""
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-file-excel")]), _vm._v("Export\n          ")], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.iqDataHeaders,
      "items": _vm.iqDataItems,
      "items-per-page": 20,
      "page": _vm.currentPage,
      "item-key": "handle",
      "loading": _vm.loading,
      "search": _vm.iqDataTableSearch,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "no-data-text": "Empty list"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [(items.length) ? _c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.handle
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "200px"
            }
          }, [_c('v-avatar', {
            attrs: {
              "size": _vm.avatarSize,
              "color": "grey lighten-4"
            }
          }, [_c('img', {
            attrs: {
              "src": item.profilePicture,
              "alt": "avatar"
            }
          })]), _vm._v(" "), (item.hidden) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('span', _vm._g({
                  staticClass: "hidden-text"
                }, on), [_vm._v("Hidden")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Hidden")])]) : _c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": _vm.platformShort === 'tiktok',
              "isInstagram": _vm.platformShort === 'instagram',
              "isYoutube": _vm.platformShort === 'youtube',
              "tiktokHandle": item.handle,
              "instagramHandle": item.handle,
              "youtubeHandle": item.handle
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.fullName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalFollowers)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.engagementRate) + "%")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.engagements)))])])
        }), 0) : _c('tbody', [_c('div', {
          staticClass: "pa-3"
        }, [_vm._v("Empty List")])])]
      }
    }], null, false, 1131942457)
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-center pt-3"
  }, [_c('v-btn', {
    staticStyle: {
      "min-width": "101px"
    },
    attrs: {
      "color": "warning"
    },
    on: {
      "click": _vm.searchNextInf
    }
  }, [_c('v-icon', [_vm._v("mdi-skip-next")]), _vm._v(" More\n      ")], 1)], 1), _vm._v(" "), (_vm.isSuperAdminRole) ? _c('v-row', [_c('v-col', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "justify-content": "center"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLocal) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "mt-3"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.fields,
      "items": _vm.items,
      "options": _vm.localPagination,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "server-items-length": _vm.localTotalItems,
      "item-key": "handle",
      "loading": _vm.localLoading,
      "no-data-text": 'Empty list'
    },
    on: {
      "update:options": function($event) {
        _vm.localPagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [(items.length) ? _c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.handle
          }, [_c('td', {
            staticClass: "text-xs-left",
            staticStyle: {
              "min-width": "200px"
            }
          }, [_c('v-avatar', {
            attrs: {
              "size": _vm.avatarSize,
              "color": "grey lighten-4"
            }
          }, [_c('img', {
            attrs: {
              "src": item.profilePicture,
              "alt": "avatar"
            }
          })]), _vm._v(" "), _c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": _vm.platformShort === 'tiktok',
              "isInstagram": _vm.platformShort === 'instagram',
              "isYoutube": _vm.platformShort === 'youtube',
              "tiktokHandle": item.handle,
              "instagramHandle": item.handle,
              "youtubeHandle": item.handle
            }
          }), _vm._v(" "), _c('v-btn', {
            staticClass: "btn-reload pl-0",
            attrs: {
              "text": "",
              "x-small": "",
              "color": "warning"
            },
            on: {
              "click": function($event) {
                return _vm.refreshReport(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "dark": "",
              "small": ""
            }
          }, [_vm._v("\n                        mdi-reload\n                      ")])], 1)], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.fullName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [(item.tags && item.tags.length > 0) ? _c('v-chip', {
            staticClass: "mr-1",
            attrs: {
              "label": "",
              "color": "green",
              "small": "",
              "text-color": "white"
            }
          }, [_c('v-icon', {
            attrs: {
              "float-left": "",
              "small": ""
            }
          }, [_vm._v("label")]), _vm._v(" \n                      " + _vm._s(item.tags[0]) + "\n                    ")], 1) : _vm._e(), _vm._v(" "), _c('v-menu', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (item.infInterests),
              expression: "item.infInterests"
            }],
            attrs: {
              "close-on-content-click": false,
              "top": "",
              "offset-x": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "show",
                    rawName: "v-show",
                    value: (item.tags && item.tags.length > 1),
                    expression: "item.tags && item.tags.length > 1"
                  }],
                  attrs: {
                    "id": 'btnMore_' + item.id,
                    "color": "primary",
                    "x-small": "",
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_vm._v("\n                          More...\n                        ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-card', {
            staticStyle: {
              "text-align": "left"
            },
            attrs: {
              "max-width": "300"
            }
          }, [_c('v-card-text', [_c('b', [_vm._v("Tags")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.tags), function(tag, index) {
            return _c('v-chip', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (index !== 0),
                expression: "index !== 0"
              }],
              key: index,
              staticClass: "ma-2",
              attrs: {
                "label": "",
                "color": "green",
                "small": "",
                "text-color": "white"
              }
            }, [_c('v-icon', {
              attrs: {
                "float-left": "",
                "small": ""
              }
            }, [_vm._v("label")]), _vm._v(" \n                          " + _vm._s(tag) + "\n                          ")], 1)
          })], 2)], 1)], 1)], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.totalFollowers)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(item.engagementRate) + "%")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.avgViews)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.avgLikes)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.avgComments)))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.avgReelPlays)))]), _vm._v(" "), _c('td', {
            staticClass: "justify-center layout px-0"
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "medium": "",
                    "color": "success"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.showReport(item)
                    }
                  }
                }, on), [_vm._v("assessment")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Audience Data")])]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "medium": "",
                    "color": "success"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.viewInfluencerPosts(item)
                    }
                  }
                }, on), [_vm._v("local_library")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Top Posts")])]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "medium": "",
                    "color": "success"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.viewRecentPosts(item)
                    }
                  }
                }, on), [_vm._v("mdi-file-clock-outline")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Recent Posts")])]), _vm._v(" "), _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "medium": "",
                    "color": "success"
                  },
                  on: {
                    "click": function($event) {
                      $event.stopPropagation();
                      return _vm.viewSimilarUsers(item)
                    }
                  }
                }, on), [_vm._v("mdi-account-group")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View Lookalikes")])])], 1)])
        }), 0) : _c('tbody', [_c('div', {
          staticClass: "pa-3"
        }, [_vm._v("Empty List")])])]
      }
    }], null, false, 3400726194)
  })], 1)])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('audience-data-report-modal', {
    attrs: {
      "audienceData": _vm.audienceDataReport
    },
    model: {
      value: (_vm.viewAudienceDataDialog),
      callback: function($$v) {
        _vm.viewAudienceDataDialog = $$v
      },
      expression: "viewAudienceDataDialog"
    }
  }), _vm._v(" "), _c('influencer-post-modal', {
    attrs: {
      "modalId": _vm.influencerPostModalId,
      "title": _vm.postsTitle,
      "platform": _vm.platformShort,
      "shortCodes": _vm.shortCodes
    }
  }), _vm._v(" "), _c('similar-users-modal', {
    attrs: {
      "handle": _vm.similarHandle,
      "items": _vm.similarItems,
      "platform": _vm.platformShort
    },
    model: {
      value: (_vm.viewSimilarUsersDialog),
      callback: function($$v) {
        _vm.viewSimilarUsersDialog = $$v
      },
      expression: "viewSimilarUsersDialog"
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewReport",
      "data-toggle": "modal",
      "data-target": _vm.audienceDataReportDisplay
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "viewPosts",
      "data-toggle": "modal",
      "data-target": _vm.influencerPostDisplay
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.overlayLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.overlayLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a8ac0a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/KeywordSearch/index.vue
// module id = 2210
// module chunks = 0